<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ 'pages.service.visitRoom.documentModal.title' | translate }}
    </h4>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body map-modal-body">
    <p>{{ 'pages.service.visitRoom.documentModal.description' | translate }}</p>
    <div class="links">
      <a href="/meklet-arhiva" target="_blank">
        {{ 'pages.service.visitRoom.documentModal.link1' | translate }}
      </a>
      <a href="https://www.archiv.org.lv/index.php?id=9099" target="_blank">
        {{ 'pages.service.visitRoom.documentModal.link2' | translate }}
        <img src="assets/images/external-link-icon.svg" alt="external-link" />
      </a>
      <a href="https://www.lna.lv/lv/meklest-lna" target="_blank">
        {{ 'pages.service.visitRoom.documentModal.link3' | translate }}
        <img src="assets/images/external-link-icon.svg" alt="external-link" />
      </a>
      <a href="https://www.lna.lv/lv/meklest-lna" target="_blank">
        {{ 'pages.service.visitRoom.documentModal.link4' | translate }}
        <img src="assets/images/external-link-icon.svg" alt="external-link" />
      </a>
      <a href="https://www.lna.lv/lv/meklest-lna" target="_blank">
        {{ 'pages.service.visitRoom.documentModal.link5' | translate }}
        <img src="assets/images/external-link-icon.svg" alt="external-link" />
      </a>
      <a href="https://www.lna.lv/lv/meklest-lna" target="_blank">
        {{ 'pages.service.visitRoom.documentModal.link6' | translate }}
        <img src="assets/images/external-link-icon.svg" alt="external-link" />
      </a>
      <a href="https://www.lna.lv/lv/meklest-lna" target="_blank">
        {{ 'pages.service.visitRoom.documentModal.link7' | translate }}
        <img src="assets/images/external-link-icon.svg" alt="external-link" />
      </a>
    </div>
  </div>
</ng-template>

<a class="open-button" (keydown.enter)="open(content)" (click)="open(content)" tabindex="0">
  {{ 'pages.service.visitRoom.documentModal.documentInfoButton' | translate }}
</a>
